export default "__VITE_ASSET__C5SCjze3__"